<span
  cdkOverlayOrigin
  #keypadOrigin="cdkOverlayOrigin"
></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="keypadOrigin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPositions]="overlayPositions"
>
  <div
    class="keypad"
  >
    <div class="value">
      <input
        #input
        [(ngModel)]="value"
        (ngModelChange)="validate()"
        (keyup.enter)="clickDone()"
      >
    </div>

    <div class="row">
      <div (click)=addNumeric(7)>
        7
      </div>
      <div (click)=addNumeric(8)>
        8
      </div>
      <div (click)=addNumeric(9)>
        9
      </div>
    </div>

    <div class="row">
      <div (click)=addNumeric(4)>
        4
      </div>
      <div (click)=addNumeric(5)>
        5
      </div>
      <div (click)=addNumeric(6)>
        6
      </div>
    </div>

    <div class="row">
      <div (click)=addNumeric(1)>
        1
      </div>
      <div (click)=addNumeric(2)>
        2
      </div>
      <div (click)=addNumeric(3)>
        3
      </div>
    </div>

    <div class="row">
      <div (click)=backspace()>
        <i class="fa-light fa-delete-left"></i>
      </div>
      <div (click)=addNumeric(0)>
        0
      </div>
      <div (click)=addDecimal()>
        <strong>.</strong>
      </div>
    </div>

    <div class="row">
      <div
        class="red"
        (click)=clickCancel()
      >
        <div>
          <i class="far fa-xmark-large"></i><br>Revert
        </div>
      </div>
      <div
        [class.green]="valid"
        [class.invalid]="!valid"
        (click)=clickDone()
      >
        <div>
          <i class="far fa-check"></i><br>Save
        </div>
      </div>
    </div>
  </div>
</ng-template>
